module.exports = __webpack_public_path__ + "static/media/opiniao_comprador_9.22273ada.png";